import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { modifyMetricData } from '../../utils/getMetrics';
import store from '../store';
import { enqueueSnackbar } from './snackbar';

export const calculateWellboreVolume = (body, loader) => async (dispatch) => {
  dispatch({ type: REDUX_ACTIONS.WELLBORE_VOLUME_LIST_LOADING });

  const { fromMD, toMD, runId } = body;

  try {
    const input = {
      input: {
        url: `/runs/volumes/${runId}`,
        method: 'POST',
        data: { from: fromMD, to: toMD },
      },
    };
    const result = await fetch.post('premiumHydraulics/proxy', input);
    if (!result.ok) throw result;
    const data = await result.json();
    const { currentUser } = store.getState();
    const currentUnit = currentUser?.preferences?.unitSystem;
    const { results, units } = data.data.detail;
    loader();
    dispatch(
      enqueueSnackbar(
        'Wellbore Volume Calculated Successfully.',
        'success',
        Date.now() + Math.random()
      )
    );
    const updatedUnits = { ...units };

    if (results?.depths && results?.volumes) {
      updatedUnits.depths = Object.fromEntries(
        Object.keys(results.depths).map((key) => [key, { ...units.depths }])
      );
      updatedUnits.volumes = Object.fromEntries(
        Object.keys(results.volumes).map((key) => [key, { ...units.volumes }])
      );
      results.depths = modifyMetricData([results.depths], updatedUnits.depths, currentUnit)[0];
      results.volumes = modifyMetricData([results.volumes], updatedUnits.volumes, currentUnit)[0];
    } else {
      updatedUnits.volumes = Object.fromEntries(
        Object.keys(results).map((key) => [key, { ...units.volumes }])
      );
      results.volumes = modifyMetricData([results], updatedUnits.volumes, currentUnit)[0];
    }
    data.data.detail.units = updatedUnits;
    dispatch({
      type: REDUX_ACTIONS.WELLBORE_VOLUME_LIST_SUCCESS,
      payload: { data: data.data },
    });
  } catch (error) {
    const errorMessage = await parseError(error);
    dispatch(
      enqueueSnackbar(
        errorMessage,
        'error',
        Date.now() + Math.random()
      )
    );
    loader();
    dispatch({ type: REDUX_ACTIONS.WELLBORE_VOLUME_RESET });
  }
};
